
class StepUtility {
  GetStepsFromHtml(rawHtmlString) {
    // Create a new DOM parser
    var parser = new DOMParser();
    // Parse the string into an HTML document
    var doc = parser.parseFromString(rawHtmlString, 'text/html');

    // Get all div elements with data-node-view-content attribute
    var divs = doc.querySelectorAll("div[data-type='draggable-item']");

    // Array to hold all JSON objects
    var jsonArray = [];

    // Iterate over each div
    divs.forEach(function (div) {
      // Get all <p> elements within the div
      var paragraphs = div.querySelectorAll('p');
      // Get the last <p> element
      var lastParagraph = paragraphs[paragraphs.length - 1];
      // Get the JSON string from the last <p> element
      var jsonString = lastParagraph.textContent || lastParagraph.innerText;
      try {
        // Parse the JSON string
        var jsonData = JSON.parse(jsonString);
        // Add the parsed JSON object to the array
        jsonArray.push(jsonData);
      } catch (e) {
        console.error("Failed to parse JSON: ", jsonString);
      }
    });

    return jsonArray;
  }

  AddManualStep(editor, subtype) {
    var id = Math.random()
    editor.chain().insertContent('<div data-type="draggable-item" data-temp-step-id=' + id + ' data-subtype="' + subtype +'"><p><strong>Step</strong></p><p></p><p></p></div>')
      .focus("end")
      .run();
  }


  //DEPRECIATED
  AddCameraStep(editor, img) {
    var id = Math.random()
    editor.chain().insertContent(`<div data-type="draggable-item" data-temp-step-id="${id}" data-subtype="camera"><p><strong>Step</strong></p><p><img src="${img}" contenteditable="false" draggable="true"></p><p></p><p></p></div>`)
      .focus("end")
      .run();

    editor.chain().keyboardShortcut('Enter').run();
  }

  AddCameraSteps(editor, steps) {
    for (let i = 0; i < steps.length; i++) {
      var id = Math.random()
      editor.chain().insertContent(`<div data-type="draggable-item" data-temp-step-id="${id}" data-subtype="camera"><p><strong>${steps[i].title}</strong></p><p>${steps[i].description}</br><img src="${steps[i].image}" contenteditable="false" draggable="true"></p><p></p><p></p></div>`)
        .focus("end")
        .run();

      editor.chain().keyboardShortcut('Enter').run();
    }
  }
}
export default new StepUtility();

